import { BILLING_LAYWERS } from "../actions/billingAction";
import { SIGN_OUT_USER } from "../actions/AuthUserAction";


const initialState = {
    billingData: {}
}

export default function billingReducer(state = initialState, action) {
  switch (action.type) {
    case BILLING_LAYWERS:
        return {
            ...state,
            billingData: action.data
        }
    case SIGN_OUT_USER:
      return {

      }
    default:
      return state;
  }
}